import { render, staticRenderFns } from "./WeddingList.vue?vue&type=template&id=7204d9b7&scoped=true&"
import script from "./WeddingList.vue?vue&type=script&lang=js&"
export * from "./WeddingList.vue?vue&type=script&lang=js&"
import style0 from "./WeddingList.vue?vue&type=style&index=0&id=7204d9b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204d9b7",
  null
  
)

export default component.exports